import { apiHelper } from '@/utils/api.helper'

export const APPOINTMENT = {
  fetchAppointments,
  checkSlot,
  bookAppointment,
  cancelAppointment,
  editAppointment,
  getAppointment
}

const URL = {
  APPOINTMENT: 'booking',
  FETCH_APPOINTMENTS: 'myappointment',
  CHECK_SLOT: 'checkslot',
  BOOK_APPOINTMENT: 'bookappointment',
  CANCEL_APPOINTMENT: 'cancelappointment',
  EDIT_APPOINTMENT: 'editappointment',
  GET_APPOINTMENT: 'getappointment'
}

function fetchAppointments(data) {
  const requestBody = {
    type: data.type, // 1: Upcoming, 2: Past
    startDate: data.startDate, // Dates are for type 2 only
    endDate: data.endDate
  }

  return apiHelper().get(`${URL.APPOINTMENT}/${URL.FETCH_APPOINTMENTS}`, {
    params: requestBody
  })
}

function checkSlot(form) {
  const requestBody = {
    store_id: form.appointmentSalon,
    stylist_id: form.appointmentStylist,
    date: form.appointmentDate
  }

  return apiHelper().post(`${URL.APPOINTMENT}/${URL.CHECK_SLOT}`, null, {
    params: requestBody
  })
}

function bookAppointment(form) {
  const requestBody = {
    store_id: form.appointmentSalon,
    stylist_id: form.appointmentStylist,
    date: form.appointmentDate,
    time: form.appointmentTimeSlots.split(' - ')[0],
    service_ids: `{"service_ids":[${form.appointmentServices}]}`,
    remarks: form.appointmentRemarks,
    status: 2 // 1 is to lock the slot for any further forms (only mobile app has that), 2 is to confirm booking
  }

  return apiHelper().post(`${URL.APPOINTMENT}/${URL.BOOK_APPOINTMENT}`, null, {
    params: requestBody
  })
}

function cancelAppointment(data) {
  const requestBody = {
    booking_id: data.booking_id
  }

  return apiHelper().put(`${URL.APPOINTMENT}/${URL.CANCEL_APPOINTMENT}`, null, {
    params: requestBody
  })
}

function editAppointment(requestBody) {
  return apiHelper().put(`${URL.APPOINTMENT}/${URL.EDIT_APPOINTMENT}`, null, {
    params: requestBody
  })
}

function getAppointment(data) {
  return apiHelper().get(`${URL.APPOINTMENT}/${URL.GET_APPOINTMENT}`, {
    params: data
  })
}
